/**
 * @generated SignedSource<<da901012fcc189194cdd4a75d8c862eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CommentCardMutation$variables = {
  flowId: UUID;
};
export type CommentCardMutation$data = {
  readonly updateViewedComments: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type CommentCardMutation = {
  response: CommentCardMutation$data;
  variables: CommentCardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "flowId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "flowId",
            "variableName": "flowId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ViewedCommentPayload",
    "kind": "LinkedField",
    "name": "updateViewedComments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentCardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentCardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "90593f91cead03c38e9c3a703b896bef",
    "id": null,
    "metadata": {},
    "name": "CommentCardMutation",
    "operationKind": "mutation",
    "text": "mutation CommentCardMutation(\n  $flowId: UUID!\n) {\n  updateViewedComments(input: {flowId: $flowId}) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d7c3d8f25c719bf4ea64726bf2c214c";

export default node;
